import React, { useEffect, useState, useCallback } from "react";
import { Typography, Rate, Select } from "antd";
import styles from "../purchaseorders/PurchaseOrders.module.scss";
import { getOrganizationId } from "../../../api/Helper";
import { getClusters } from "../../../api/Services";

interface Recomendacion {
  proveedor: string;
  articulo: string;
  categoria: string;
  precio: number;
  condiciones: string;
  recomendacion: number;
  foto: string;
}

const Recomendations: React.FC = () => {
  const [data, setData] = useState<Recomendacion[]>([]);
  const [filtered, setFiltered] = useState<Recomendacion[]>([]);
  const [proveedor, setProveedor] = useState<string | undefined>(undefined);
  const [categoria, setCategoria] = useState<string | undefined>(undefined);
  const [isOrg5, setIsOrg5] = useState(false);
  const [clusters, setClusters] = useState<any[]>([]);
  const [clusterFilterValue, setClusterFilterValue] = useState<string | undefined>(undefined);

  const handleSearchClusters = useCallback(async () => {
    try {
      const response = await getClusters(1);
      setClusters(response.clusters || []);
    } catch (error) {
      console.error("Error fetching clusters:", error);
    }
  }, []);

  useEffect(() => {
    getOrganizationId().then((orgId) => {
      setIsOrg5(parseInt(orgId) === 5);
    });
    handleSearchClusters();
    import("./hardcodedData.json").then((mod) => {
      const d = mod.default ?? mod;
      setData(d);
      setFiltered(d);
    });
  }, [handleSearchClusters]);

  useEffect(() => {
    let result = data;
    if (proveedor) result = result.filter((r) => r.proveedor === proveedor);
    if (categoria) result = result.filter((r) => r.categoria === categoria);
    // TODO: Implementar filtro por cluster cuando esté disponible el backend
    // if (clusterFilterValue) result = result.filter((r) => r.cluster === clusterFilterValue);
    setFiltered(result);
  }, [proveedor, categoria, clusterFilterValue, data]);

  if (!isOrg5) return null;

  const proveedores = Array.from(new Set(data.map((d) => d.proveedor)));
  const categorias = Array.from(new Set(data.map((d) => d.categoria)));

  return (
    <div style={{ maxWidth: 1100, margin: "0 auto", padding: 32 }}>
      <Typography.Title level={2} style={{ marginBottom: 32, fontWeight: 700 }}>
        Recomendaciones de artículos para proveedores
      </Typography.Title>
      <div style={{ display: "flex", gap: 16, marginBottom: 24 }}>
        <Select
          allowClear
          placeholder="Proveedor"
          style={{ minWidth: 200 }}
          value={proveedor}
          onChange={setProveedor}
        >
          {proveedores.map((p) => (
            <Select.Option key={p} value={p}>
              {p}
            </Select.Option>
          ))}
        </Select>
        <Select
          allowClear
          placeholder="Categoría"
          style={{ minWidth: 200 }}
          value={categoria}
          onChange={setCategoria}
        >
          {categorias.map((c) => (
            <Select.Option key={c} value={c}>
              {c}
            </Select.Option>
          ))}
        </Select>
        <Select
          allowClear
          placeholder="Cluster"
          style={{ minWidth: 250 }}
          value={clusterFilterValue}
          onChange={setClusterFilterValue}
        >
          {clusters.map((cluster) => (
            <Select.Option key={cluster.id} value={cluster.id}>
              {cluster.name}
            </Select.Option>
          ))}
        </Select>
      </div>
      <div style={{ background: "#fff", borderRadius: 16, padding: 24, boxShadow: "0 2px 8px #0001" }}>
        <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
          <thead>
            <tr style={{ textAlign: "left", fontWeight: 600, fontSize: 16 }}>
              <th></th>
              <th>Proveedor</th>
              <th>Artículo</th>
              <th>Categoría</th>
              <th>Precio de costo</th>
              <th>Condiciones</th>
              <th>Recomendación</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((item, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #eee", verticalAlign: "middle" }}>
                <td style={{ padding: 12 }}>
                  <img src={item.foto} alt={item.articulo} style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 8 }} />
                </td>
                <td style={{ padding: 12 }}>{item.proveedor}</td>
                <td style={{ padding: 12 }}>{item.articulo}</td>
                <td style={{ padding: 12 }}>{item.categoria}</td>
                <td style={{ padding: 12 }}>${item.precio}</td>
                <td style={{ padding: 12, minWidth: 180 }}>{item.condiciones}</td>
                <td style={{ padding: 12, minWidth: 160, textAlign: 'center', verticalAlign: 'middle' }}>
                  <Rate disabled value={item.recomendacion} count={5} allowHalf={false} style={{ fontSize: 18 }} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Recomendations; 